export default template;
function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_classes(s,r){return Array.isArray(s)?pug_classes_array(s,r):s&&"object"==typeof s?pug_classes_object(s):s||""}
function pug_classes_array(r,a){for(var s,e="",u="",c=Array.isArray(a),g=0;g<r.length;g++)(s=pug_classes(r[g]))&&(c&&a[g]&&(s=pug_escape(s)),e=e+u+s,u=" ");return e}
function pug_classes_object(r){var a="",n="";for(var o in r)o&&r[o]&&pug_has_own_property.call(r,o)&&(a=a+n+o,n=" ");return a}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_has_own_property=Object.prototype.hasOwnProperty;
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (calcStateClass, getDirectionsUrl, labelDate, orders, prettyOption) {
      pug_mixins["render_address"] = pug_interp = function(address, order, suppressName, directionsUrl){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"address\"\u003E";
if (directionsUrl) {
pug_html = pug_html + "\u003Ca" + (" class=\"directions\""+" target=\"_blank\""+pug_attr("href", directionsUrl, true, true)) + "\u003E\u003Cimg src=\"images\u002Fnavigation.png\"\u003E\u003C\u002Fa\u003E";
}
if (! suppressName) {
pug_html = pug_html + "\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = address.fullName && address.fullName.firstName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = address.fullName && address.fullName.lastName) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (address.company) {
pug_html = pug_html + "\u003Cdiv class=\"company\"\u003E" + (pug_escape(null == (pug_interp = address.company) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"line\"\u003E";
if (address.street) {
pug_html = pug_html + ((pug_escape(null == (pug_interp = address.street.number) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = address.street.name) ? "" : pug_interp)));
}
else {
pug_html = pug_html + (pug_escape(null == (pug_interp = address.addressLine1) ? "" : pug_interp));
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (address.addressLine2) {
pug_html = pug_html + "\u003Cdiv class=\"line\"\u003E" + (pug_escape(null == (pug_interp = address.addressLine2) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (order && order.customField && order.customField.title == "Apartment Number, suite, etc") {
pug_html = pug_html + "\u003Cdiv class=\"line\"\u003E" + (pug_escape(null == (pug_interp = order.customField.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"city\"\u003E" + (pug_escape(null == (pug_interp = address.city) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = address.zipCode) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
if (! suppressName) {
pug_html = pug_html + "\u003Cdiv class=\"phone\"\u003E" + (pug_escape(null == (pug_interp = address.phone) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (address.business) {
pug_html = pug_html + "\u003Cdiv class=\"line\"\u003E\u003Cstrong\u003E(Business)\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"function-body\"\u003E";
if (orders.length > 0) {
pug_html = pug_html + "\u003Cdiv class=\"list-orders\"\u003E";
// iterate orders
;(function(){
  var $$obj = orders;
  if ('number' == typeof $$obj.length) {
      for (var idx = 0, $$l = $$obj.length; idx < $$l; idx++) {
        var order = $$obj[idx];
var stateClass = calcStateClass(order)
// iterate order.lineItems
;(function(){
  var $$obj = order.lineItems;
  if ('number' == typeof $$obj.length) {
      for (var lidx = 0, $$l = $$obj.length; lidx < $$l; lidx++) {
        var lineItem = $$obj[lidx];
var shipmentDetailsAddress = order.shippingInfo && order.shippingInfo.shipmentDetails && order.shippingInfo.shipmentDetails.address;
pug_html = pug_html + ("\u003Cdiv" + (pug_attr("class", pug_classes(["order-container",stateClass], [false,true]), false, true)) + "\u003E\u003Cdiv class=\"order\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cdiv\u003E\u003Ca" + (" class=\"clickable\""+pug_attr("href", `#/orders/view/${order.id}`, true, true)) + "\u003EOrder " + (pug_escape(null == (pug_interp = order.number) ? "" : pug_interp)));
if (order.business) {
pug_html = pug_html + "\n\u003Cstrong\u003E" + (pug_escape(null == (pug_interp = order.business) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + ("\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = lineItem.name) ? "" : pug_interp)));
if (lineItem.quantity > 1) {
pug_html = pug_html + "\n\u003Cstrong\u003EQuantity: " + (pug_escape(null == (pug_interp = lineItem.quantity) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"options\"\u003E";
// iterate (lineItem.options || [])
;(function(){
  var $$obj = (lineItem.options || []);
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var option = $$obj[pug_index2];
if (option.selection != "No" && option.option.indexOf("Add ") == 0) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = prettyOption(option)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var option = $$obj[pug_index2];
if (option.selection != "No" && option.option.indexOf("Add ") == 0) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = prettyOption(option)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"buyer\"\u003EBuyer: " + (pug_escape(null == (pug_interp = order.buyerInfo.firstName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = order.buyerInfo.lastName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = order.buyerInfo.phone) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"deliverInfo\"\u003E";
if (shipmentDetailsAddress) {
pug_html = pug_html + "\u003Ca" + (" class=\"clickable directions noprint\""+" target=\"_blank\""+pug_attr("href", getDirectionsUrl(order), true, true)) + "\u003E\u003Cimg class=\"navigation\" src=\"images\u002Fnavigation.png\"\u003E\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"date\"\u003E" + (pug_escape(null == (pug_interp = labelDate(order.deliveryDate)) ? "" : pug_interp)) + "\n";
if (order.deliveryAfter || order.deliveryBefore) {
pug_html = pug_html + "\u003Cdiv\u003E";
if (order.deliveryAfter) {
pug_html = pug_html + "\u003Cstrong\u003E\nafter " + (pug_escape(null == (pug_interp = order.deliveryAfter) ? "" : pug_interp)) + "\n\u003C\u002Fstrong\u003E";
}
if (order.deliveryBefore) {
pug_html = pug_html + "\u003Cstrong\u003E                                                       |\nbefore " + (pug_escape(null == (pug_interp = order.deliveryBefore) ? "" : pug_interp)) + "\n\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (shipmentDetailsAddress) {
pug_html = pug_html + "\u003Cdiv class=\"delivery-address\"\u003E";
pug_mixins["render_address"](shipmentDetailsAddress, order);
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var lidx in $$obj) {
      $$l++;
      var lineItem = $$obj[lidx];
var shipmentDetailsAddress = order.shippingInfo && order.shippingInfo.shipmentDetails && order.shippingInfo.shipmentDetails.address;
pug_html = pug_html + ("\u003Cdiv" + (pug_attr("class", pug_classes(["order-container",stateClass], [false,true]), false, true)) + "\u003E\u003Cdiv class=\"order\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cdiv\u003E\u003Ca" + (" class=\"clickable\""+pug_attr("href", `#/orders/view/${order.id}`, true, true)) + "\u003EOrder " + (pug_escape(null == (pug_interp = order.number) ? "" : pug_interp)));
if (order.business) {
pug_html = pug_html + "\n\u003Cstrong\u003E" + (pug_escape(null == (pug_interp = order.business) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + ("\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = lineItem.name) ? "" : pug_interp)));
if (lineItem.quantity > 1) {
pug_html = pug_html + "\n\u003Cstrong\u003EQuantity: " + (pug_escape(null == (pug_interp = lineItem.quantity) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"options\"\u003E";
// iterate (lineItem.options || [])
;(function(){
  var $$obj = (lineItem.options || []);
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var option = $$obj[pug_index3];
if (option.selection != "No" && option.option.indexOf("Add ") == 0) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = prettyOption(option)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var option = $$obj[pug_index3];
if (option.selection != "No" && option.option.indexOf("Add ") == 0) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = prettyOption(option)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"buyer\"\u003EBuyer: " + (pug_escape(null == (pug_interp = order.buyerInfo.firstName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = order.buyerInfo.lastName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = order.buyerInfo.phone) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"deliverInfo\"\u003E";
if (shipmentDetailsAddress) {
pug_html = pug_html + "\u003Ca" + (" class=\"clickable directions noprint\""+" target=\"_blank\""+pug_attr("href", getDirectionsUrl(order), true, true)) + "\u003E\u003Cimg class=\"navigation\" src=\"images\u002Fnavigation.png\"\u003E\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"date\"\u003E" + (pug_escape(null == (pug_interp = labelDate(order.deliveryDate)) ? "" : pug_interp)) + "\n";
if (order.deliveryAfter || order.deliveryBefore) {
pug_html = pug_html + "\u003Cdiv\u003E";
if (order.deliveryAfter) {
pug_html = pug_html + "\u003Cstrong\u003E\nafter " + (pug_escape(null == (pug_interp = order.deliveryAfter) ? "" : pug_interp)) + "\n\u003C\u002Fstrong\u003E";
}
if (order.deliveryBefore) {
pug_html = pug_html + "\u003Cstrong\u003E                                                       |\nbefore " + (pug_escape(null == (pug_interp = order.deliveryBefore) ? "" : pug_interp)) + "\n\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (shipmentDetailsAddress) {
pug_html = pug_html + "\u003Cdiv class=\"delivery-address\"\u003E";
pug_mixins["render_address"](shipmentDetailsAddress, order);
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

      }
  } else {
    var $$l = 0;
    for (var idx in $$obj) {
      $$l++;
      var order = $$obj[idx];
var stateClass = calcStateClass(order)
// iterate order.lineItems
;(function(){
  var $$obj = order.lineItems;
  if ('number' == typeof $$obj.length) {
      for (var lidx = 0, $$l = $$obj.length; lidx < $$l; lidx++) {
        var lineItem = $$obj[lidx];
var shipmentDetailsAddress = order.shippingInfo && order.shippingInfo.shipmentDetails && order.shippingInfo.shipmentDetails.address;
pug_html = pug_html + ("\u003Cdiv" + (pug_attr("class", pug_classes(["order-container",stateClass], [false,true]), false, true)) + "\u003E\u003Cdiv class=\"order\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cdiv\u003E\u003Ca" + (" class=\"clickable\""+pug_attr("href", `#/orders/view/${order.id}`, true, true)) + "\u003EOrder " + (pug_escape(null == (pug_interp = order.number) ? "" : pug_interp)));
if (order.business) {
pug_html = pug_html + "\n\u003Cstrong\u003E" + (pug_escape(null == (pug_interp = order.business) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + ("\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = lineItem.name) ? "" : pug_interp)));
if (lineItem.quantity > 1) {
pug_html = pug_html + "\n\u003Cstrong\u003EQuantity: " + (pug_escape(null == (pug_interp = lineItem.quantity) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"options\"\u003E";
// iterate (lineItem.options || [])
;(function(){
  var $$obj = (lineItem.options || []);
  if ('number' == typeof $$obj.length) {
      for (var pug_index5 = 0, $$l = $$obj.length; pug_index5 < $$l; pug_index5++) {
        var option = $$obj[pug_index5];
if (option.selection != "No" && option.option.indexOf("Add ") == 0) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = prettyOption(option)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index5 in $$obj) {
      $$l++;
      var option = $$obj[pug_index5];
if (option.selection != "No" && option.option.indexOf("Add ") == 0) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = prettyOption(option)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"buyer\"\u003EBuyer: " + (pug_escape(null == (pug_interp = order.buyerInfo.firstName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = order.buyerInfo.lastName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = order.buyerInfo.phone) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"deliverInfo\"\u003E";
if (shipmentDetailsAddress) {
pug_html = pug_html + "\u003Ca" + (" class=\"clickable directions noprint\""+" target=\"_blank\""+pug_attr("href", getDirectionsUrl(order), true, true)) + "\u003E\u003Cimg class=\"navigation\" src=\"images\u002Fnavigation.png\"\u003E\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"date\"\u003E" + (pug_escape(null == (pug_interp = labelDate(order.deliveryDate)) ? "" : pug_interp)) + "\n";
if (order.deliveryAfter || order.deliveryBefore) {
pug_html = pug_html + "\u003Cdiv\u003E";
if (order.deliveryAfter) {
pug_html = pug_html + "\u003Cstrong\u003E\nafter " + (pug_escape(null == (pug_interp = order.deliveryAfter) ? "" : pug_interp)) + "\n\u003C\u002Fstrong\u003E";
}
if (order.deliveryBefore) {
pug_html = pug_html + "\u003Cstrong\u003E                                                       |\nbefore " + (pug_escape(null == (pug_interp = order.deliveryBefore) ? "" : pug_interp)) + "\n\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (shipmentDetailsAddress) {
pug_html = pug_html + "\u003Cdiv class=\"delivery-address\"\u003E";
pug_mixins["render_address"](shipmentDetailsAddress, order);
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var lidx in $$obj) {
      $$l++;
      var lineItem = $$obj[lidx];
var shipmentDetailsAddress = order.shippingInfo && order.shippingInfo.shipmentDetails && order.shippingInfo.shipmentDetails.address;
pug_html = pug_html + ("\u003Cdiv" + (pug_attr("class", pug_classes(["order-container",stateClass], [false,true]), false, true)) + "\u003E\u003Cdiv class=\"order\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cdiv\u003E\u003Ca" + (" class=\"clickable\""+pug_attr("href", `#/orders/view/${order.id}`, true, true)) + "\u003EOrder " + (pug_escape(null == (pug_interp = order.number) ? "" : pug_interp)));
if (order.business) {
pug_html = pug_html + "\n\u003Cstrong\u003E" + (pug_escape(null == (pug_interp = order.business) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + ("\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = lineItem.name) ? "" : pug_interp)));
if (lineItem.quantity > 1) {
pug_html = pug_html + "\n\u003Cstrong\u003EQuantity: " + (pug_escape(null == (pug_interp = lineItem.quantity) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"options\"\u003E";
// iterate (lineItem.options || [])
;(function(){
  var $$obj = (lineItem.options || []);
  if ('number' == typeof $$obj.length) {
      for (var pug_index6 = 0, $$l = $$obj.length; pug_index6 < $$l; pug_index6++) {
        var option = $$obj[pug_index6];
if (option.selection != "No" && option.option.indexOf("Add ") == 0) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = prettyOption(option)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index6 in $$obj) {
      $$l++;
      var option = $$obj[pug_index6];
if (option.selection != "No" && option.option.indexOf("Add ") == 0) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = prettyOption(option)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"buyer\"\u003EBuyer: " + (pug_escape(null == (pug_interp = order.buyerInfo.firstName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = order.buyerInfo.lastName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = order.buyerInfo.phone) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"deliverInfo\"\u003E";
if (shipmentDetailsAddress) {
pug_html = pug_html + "\u003Ca" + (" class=\"clickable directions noprint\""+" target=\"_blank\""+pug_attr("href", getDirectionsUrl(order), true, true)) + "\u003E\u003Cimg class=\"navigation\" src=\"images\u002Fnavigation.png\"\u003E\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"date\"\u003E" + (pug_escape(null == (pug_interp = labelDate(order.deliveryDate)) ? "" : pug_interp)) + "\n";
if (order.deliveryAfter || order.deliveryBefore) {
pug_html = pug_html + "\u003Cdiv\u003E";
if (order.deliveryAfter) {
pug_html = pug_html + "\u003Cstrong\u003E\nafter " + (pug_escape(null == (pug_interp = order.deliveryAfter) ? "" : pug_interp)) + "\n\u003C\u002Fstrong\u003E";
}
if (order.deliveryBefore) {
pug_html = pug_html + "\u003Cstrong\u003E                                                       |\nbefore " + (pug_escape(null == (pug_interp = order.deliveryBefore) ? "" : pug_interp)) + "\n\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (shipmentDetailsAddress) {
pug_html = pug_html + "\u003Cdiv class=\"delivery-address\"\u003E";
pug_mixins["render_address"](shipmentDetailsAddress, order);
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }.call(this, "calcStateClass" in locals_for_with ?
        locals_for_with.calcStateClass :
        typeof calcStateClass !== 'undefined' ? calcStateClass : undefined, "getDirectionsUrl" in locals_for_with ?
        locals_for_with.getDirectionsUrl :
        typeof getDirectionsUrl !== 'undefined' ? getDirectionsUrl : undefined, "labelDate" in locals_for_with ?
        locals_for_with.labelDate :
        typeof labelDate !== 'undefined' ? labelDate : undefined, "orders" in locals_for_with ?
        locals_for_with.orders :
        typeof orders !== 'undefined' ? orders : undefined, "prettyOption" in locals_for_with ?
        locals_for_with.prettyOption :
        typeof prettyOption !== 'undefined' ? prettyOption : undefined));
    ;;return pug_html;}